module.exports = __webpack_public_path__ + "static/bg_flag-1fee6aceb8bb2cfb57f328531f36da39.jpg";